<dx-popup
  title="Connexion à Ma Cantine"
  [(visible)]="displayed"
  resizeEnabled="true"
  width="600"
  height="auto">
  <div class="dialog-line" *ngIf="isReseted">
    <div class="label">
      <span>Site ma cantine</span>
    </div>
    <div class="value link-container">
      <yo-text-box
        [value]="maCantineUri"
        [readonly]="!isReseted"
        disabled="true"
        (onValueChanged)="onClientIdEdit($event)">
      </yo-text-box>
      <yo-button
        class="open-link"
        size="small"
        title="Ouvrir le site dans un nouvel onglet"
        iconClass="fas fa-external-link"
        [theme]="ButtonThemeEnum.EMPTY_INNER"
        (onClick)="openMaCantine()"
      >
      </yo-button>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>ID du client</span>
    </div>
    <div class="value">
      <yo-text-box
        [value]="maCantineClientId"
        [readonly]="!isReseted"
        (onValueChanged)="onClientIdEdit($event)">
      </yo-text-box>
    </div>
  </div>
  <div class="dialog-line" *ngIf="isReseted">
    <div class="label">
      <span>Secret client</span>
    </div>
    <div class="value">
      <yo-text-box
        [value]="maCantineClientSecret"
        autoComplete="ma-cantine-secret"
        secret="true"
        (onValueChanged)="onClientSecretEdit($event)">
      </yo-text-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>Redirect URI</span>
    </div>
    <div class="value">
      <yo-text-box
        copy="true"
        [value]="getRedirectUri()"
        disabled="true">
      </yo-text-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-left">
      <yo-button
        *ngIf="!isReseted"
        [theme]="ButtonThemeEnum.CANCEL"
        iconClass="fas fa-power-off"
        tooltip="Réinitialiser"
        (onClick)="reset()">
      </yo-button>
    </div>
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fas fa-save"
        tooltip="Sauvegarder"
        [disabled]="!isEdited"
        (onClick)="save()">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.DEFAULT"
        iconClass="fas fa-wifi"
        tooltip="Connexion"
        [disabled]="!(maCantineConnection?.clientId && !maCantineConnection?.isConnected && !isReseted)"
        (onClick)="connect()">
      </yo-button>
    </div>
  </div>
</dx-popup>
